import { ClosedReason, SuretyAccountId, SuretyAccountStatus } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountQueryKey } from "../account.keys";

export const useAdminCloseAccount = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			closedReason,
			note,
		}: {
			closedReason: ClosedReason;
			note?: string;
			onSuccess?: () => void;
		}) => {
			await patch(
				`/v2/admin/surety/accounts/${accountId}/status`,
				{ status: SuretyAccountStatus.closed, closedReason, note },
				"none",
			);
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
		onSuccess: (_, { onSuccess }) => {
			onSuccess?.();
		},
	});

	return {
		closeAccount: mutation.mutate,
		closeAccountError: mutation.error,
		closeAccountLoading: mutation.isPending,
		dismissCloseAccountError: () => {
			mutation.reset();
		},
	};
};
